function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M497,181c8.284,0,15-6.716,15-15v-60c0-8.284-6.716-15-15-15h-46c0-33.084-26.916-60-60-60 c-17.908,0-33.997,7.896-45,20.377C334.997,38.896,318.908,31,301,31c-17.908,0-33.997,7.896-45,20.377 C244.997,38.896,228.908,31,211,31s-33.997,7.896-45,20.377C154.997,38.896,138.908,31,121,31c-33.084,0-60,26.916-60,60H30V76 c0-8.284-6.716-15-15-15S0,67.716,0,76v120c0,8.284,6.716,15,15,15s15-6.716,15-15v-15h31v120H30v-15c0-8.284-6.716-15-15-15 s-15,6.716-15,15v120c0,8.284,6.716,15,15,15s15-6.716,15-15v-15h31v30c0,33.084,26.916,60,60,60c17.908,0,33.997-7.896,45-20.377 C177.003,473.104,193.092,481,211,481s33.997-7.896,45-20.377C267.003,473.104,283.092,481,301,481 c17.908,0,33.997-7.896,45-20.377C357.003,473.104,373.092,481,391,481c33.084,0,60-26.916,60-60v-30h46c8.284,0,15-6.716,15-15 v-60c0-8.284-6.716-15-15-15h-46V181H497z M451,121h31v30h-31V121z M61,361H30v-30h31V361z M61,151H30v-30h31V151z M151,421 c0,16.542-13.458,30-30,30s-30-13.458-30-30V91c0-16.542,13.458-30,30-30s30,13.458,30,30V421z M241,421c0,16.542-13.458,30-30,30 s-30-13.458-30-30V91c0-16.542,13.458-30,30-30s30,13.458,30,30V421z M331,421c0,16.542-13.458,30-30,30s-30-13.458-30-30V91 c0-16.542,13.458-30,30-30s30,13.458,30,30V421z M421,421c0,16.542-13.458,30-30,30s-30-13.458-30-30V91c0-16.542,13.458-30,30-30 s30,13.458,30,30V421z M482,331v30h-31v-30H482z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg512(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg512);
export default __webpack_public_path__ + "static/media/5_12.db1c60e4.svg";
export { ForwardRef as ReactComponent };